/**
 * Idea management service
 * All idea CRUD operations via Lambda REST API
 */
import { lambdaClient } from '../config/http.client';

/** Create a new idea (Idea Owner). Pass is_draft=true to save as draft. */
export const createIdea = async (ideaData) => {
  const response = await lambdaClient.post('/ideas', ideaData);
  return response.data;
};

/** Fetch list of ideas (filtered server-side by role). */
export const getIdeas = async (params = {}) => {
  const response = await lambdaClient.get('/ideas', { params });
  return response.data;
};

/** Fetch a single idea by ID. */
export const getIdeaById = async (ideaId) => {
  const response = await lambdaClient.get(`/ideas/${ideaId}`);
  return response.data;
};

/** Update idea fields (owner in DRAFT/SENT_BACK, or admin). */
export const updateIdea = async (ideaId, fields) => {
  const response = await lambdaClient.put(`/ideas/${ideaId}`, fields);
  return response.data;
};

/** Transition idea status. body = { status, reason? } */
export const updateIdeaStatus = async (ideaId, body) => {
  const response = await lambdaClient.put(`/ideas/${ideaId}/status`, body);
  return response.data;
};

/** Assign managers to an idea (Admin only). body = { managers: [email] } */
export const assignManagers = async (ideaId, managers) => {
  const response = await lambdaClient.put(`/ideas/${ideaId}/assign`, { managers });
  return response.data;
};

/** Add a comment to an idea. */
export const addComment = async (ideaId, commentData) => {
  const response = await lambdaClient.post(`/ideas/${ideaId}/comments`, commentData);
  return response.data;
};

/** Submit a rating for an idea (Manager only). */
export const rateIdea = async (ideaId, rating) => {
  const response = await lambdaClient.put(`/ideas/${ideaId}/rate`, rating);
  return response.data;
};

/** Flag an idea for peer review (Manager only). */
export const flagIdea = async (ideaId, reason = 'peer_review') => {
  const response = await lambdaClient.put(`/ideas/${ideaId}/flag`, { reason });
  return response.data;
};

/** Delete an idea (Admin only). */
export const deleteIdea = async (ideaId) => {
  const response = await lambdaClient.delete(`/ideas/${ideaId}`);
  return response.data;
};
